/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19"
        height="16.03"
        viewBox="0 0 19 16.03"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M19 2.5a2.54 2.54 0 0 0-2.54-2.53H2.53A2.53 2.53 0 0 0 0 2.5v11a2.53 2.53 0 0 0 2.53 2.53h13.93A2.54 2.54 0 0 0 19 13.5Zm-1 11a1.53 1.53 0 0 1-1.54 1.53H2.53A1.52 1.52 0 0 1 1 13.5v-11A1.53 1.53 0 0 1 2.53.97h13.93A1.54 1.54 0 0 1 18 2.5ZM9.54 3.17a4.92 4.92 0 1 0 4.92 4.92 4.93 4.93 0 0 0-4.92-4.92Zm0 1a3.87 3.87 0 0 1 2.4.84L10.86 6.1a2.36 2.36 0 0 0-2.63 0L7.19 5.01a3.79 3.79 0 0 1 2.39-.84Zm1.4 3.92a1.4 1.4 0 1 1-1.4-1.4 1.4 1.4 0 0 1 1.4 1.4Zm-5.31 0a3.83 3.83 0 0 1 .82-2.37L7.53 6.8a2.36 2.36 0 0 0 0 2.6l-1.07 1.1a3.91 3.91 0 0 1-.84-2.39Zm3.92 3.92a3.83 3.83 0 0 1-2.37-.82l1.07-1.09a2.4 2.4 0 0 0 2.59 0l1.08 1.09a3.81 3.81 0 0 1-2.38.83Zm3.08-1.54-1.08-1.08a2.37 2.37 0 0 0 0-2.58l1.08-1.08a3.82 3.82 0 0 1 0 4.74Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'VaultIcon';

export default Icon;
